"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextTermsAndConditions = exports.StyledSkipButton = exports.CtaChildrenWrapper = exports.StyledCtaButton = exports.StyledCtaContainer = exports.CtaWrapper = exports.StyledFlex = exports.InputWrapper = exports.FormFields = exports.MandatoryFields = exports.StyledTitle = exports.StyledHeader = exports.StyledSection = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.StyledSection = (0, flora_react_1.styled)('section', {
    width: '100%',
    display: 'flex',
    background: '$light-light',
});
exports.StyledHeader = (0, flora_react_1.styled)('div', {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    alignContent: 'space-between',
    paddingTop: '$5',
});
exports.StyledTitle = (0, flora_react_1.styled)(flora_react_1.Text, {
    fontWeight: '$medium',
    fontStyle: 'normal',
    fontSize: '$xxl',
    paddingRight: '$7',
});
exports.MandatoryFields = (0, flora_react_1.styled)(flora_react_1.Text, {
    marginTop: '$5',
    color: '$error-standard',
    display: 'block',
    fontWeight: '$medium',
});
exports.FormFields = (0, flora_react_1.styled)('div', {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '$4 auto 0',
});
exports.InputWrapper = (0, flora_react_1.styled)('div', {
    display: 'block',
    width: '100%',
    marginBottom: '$3',
});
exports.StyledFlex = (0, flora_react_1.styled)(flora_react_1.Flex, {
    marginBottom: '$4',
    '&:last-child': {
        marginBottom: '$0',
    },
});
// Start TODO: Extract to molecule CallToAction.tsx
exports.CtaWrapper = (0, flora_react_1.styled)('div', {
    width: '100%',
    display: 'flex',
    background: '$light-light',
    paddingTop: '$4',
});
exports.StyledCtaContainer = (0, flora_react_1.styled)('div', {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
});
exports.StyledCtaButton = (0, flora_react_1.styled)(flora_react_1.Button, {
    variants: {
        hasDisclaimer: {
            true: {
                marginBottom: '$3',
            },
        },
    },
});
exports.CtaChildrenWrapper = (0, flora_react_1.styled)('div', {
    width: '100%',
    display: 'flex',
    marginTop: '$9',
});
exports.StyledSkipButton = (0, flora_react_1.styled)(flora_react_1.Button, {
    textDecorationLine: 'underline',
});
// End TODO: Extract to molecule CallToAction.tsx
// Start TODO: Extract to molecule TermsAndConditions.tsx
exports.StyledTextTermsAndConditions = (0, flora_react_1.styled)(flora_react_1.Text, {
    display: 'block',
    color: '$medium-light-1',
    a: {
        color: '$brand-1',
        textDecoration: 'underline',
    },
});
// End TODO: Extract to molecule TermsAndConditions.tsx
